import { useEffect, useState, type ReactNode } from 'react';
import {
  APP_SETTINGS_DEFAULTS,
  STORE_INFO_DEFAULTS,
  type AppSettings,
  type PublicSettings,
  type StoreInfo,
} from '@rosita/shared';
import { api } from './api';
import { AppSettingsContext } from './appSettings';

export function AppSettingsProvider({ children }: { children: ReactNode }): JSX.Element {
  const [settings, setSettings] = useState<AppSettings>(APP_SETTINGS_DEFAULTS);
  const [storeInfo, setStoreInfo] = useState<StoreInfo>(STORE_INFO_DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const res = await api.get<PublicSettings>('/settings');
        if (cancelled) return;
        const { storeInfo: info, ...rest } = res.data;
        setSettings((prev) => ({ ...prev, ...rest }));
        if (info) setStoreInfo(info);
      } catch {
        // Fall back to defaults silently — storefront still renders.
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <AppSettingsContext.Provider value={{ settings, storeInfo, loaded }}>
      {children}
    </AppSettingsContext.Provider>
  );
}
